(function ($) {
  'use strict';

  $(document).ready(function () {
    $('.consent-toggle').on('change', function () {
      const $checkbox = $(this);
      const consentKey = $checkbox.data('consent');
      let consentValue = '0';
      if ($checkbox.is(':checked')) {
        consentValue = '1';
      }

      $checkbox.prop('disabled', true);

      $.ajax({
        url: window.ajax_callback_data.ajax_url,
        type: 'POST',
        data: {
          action: 'save_user_consent',
          consent_key: consentKey,
          consent_value: consentValue,
          nonce: window.ajax_callback_data.ajax_nonce,
        },
        success: function (response) {
          if (!response.success) {
            console.error('Error saving consent:', response.data);
            $checkbox.prop('checked', !$checkbox.is(':checked'));
          }
        },
        error: function (xhr, status, error) {
          console.error('AJAX error:', error);
          $checkbox.prop('checked', !$checkbox.is(':checked'));
        },
        complete: function () {
          $checkbox.prop('disabled', false);
        },
      });
    });
  });
})(jQuery);
